module.exports = __webpack_public_path__ + "static/media/img104.4dd6cd1c.jpg";